<template>
  <div class="wait" v-if="isShow">
    <div class="wait-nr">
      <img src="./Loading/loading.gif">
      <p>{{msg}}</p>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      msg: {
        type: String,
        default: ''
      },
      isShow: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="less" scoped>
  .wait {
    position: fixed;
    top: 35%;
    z-index: 9999;
    text-align: center;
    margin: 0 auto;
    width: 100%;
  }

  .wait-nr {
    background-color: rgba(0, 0, 0, 0.7);
    /*background-color: #ece4de;*/
    border-radius: 5px;
    color: #fff;
    text-align: center;
    padding: 15px 20px;
    margin: 0 10px;
    display: inline-block;
  }

  .wait-nr img {
    width: 30px;
    margin-bottom: 5px;
  }

</style>



// WEBPACK FOOTER //
// src/components/base/wait.vue